module.exports = __webpack_public_path__ + "img/sq4m_02.d958beac.jpg";